"use strict";
//#region State Props
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auto = exports.Forced = exports.Blurred = exports.Default = exports.QualityGroup = void 0;
const state_flow_1 = require("@video/state-flow");
const encoding_selectors_1 = require("../../drivers/encoding-selectors");
const helpers_1 = require("../helpers");
const state_flow_2 = require("../state-flow");
//#endregion
//#region Group Declaration
exports.QualityGroup = state_flow_2.PlayerStateFlow.registerGroup("quality").bootstrap(() => {
    return (0, exports.Default)({
        availableQualities: [],
        preferredQuality: null,
        currentQuality: null,
        encodingSelector: new encoding_selectors_1.HighestBitrateSelector(),
    });
});
//#endregion
//#region Signals Handlers
function requestForcedQuality(states, signal) {
    const [driverName, driver] = (0, helpers_1.getCurrentDriver)(states);
    const quality = signal.quality;
    if (driverName === null) {
        return state_flow_1.Result.reject("no driver selected");
    }
    if (quality == null) {
        return (0, exports.Default)({ ...states.quality, preferredQuality: null });
    }
    if (quality.startsWith("source:") && driver.features.sourceQuality) {
        return state_flow_1.Result.reject("source quality is only supported for WebRTC driver");
    }
    if (!driver.features.forcedQuality) {
        return state_flow_1.Result.reject("driver does not support forced quality");
    }
    return (0, exports.Forced)({ ...states.quality, preferredQuality: quality });
}
//#endregion
//#region States Declarations
exports.Default = exports.QualityGroup.registerState("Highest", {
    requestForcedQuality,
});
exports.Blurred = exports.QualityGroup.registerState("Blurred", {});
exports.Forced = exports.QualityGroup.registerState("Forced", {});
exports.Auto = exports.QualityGroup.registerState("Auto", {});
//#endregion
//# sourceMappingURL=quality.js.map